// Planned picture for each photo space, from docs/final-photo-review/photo-selection.csv
// (article titles omitted; they already appear beside each article space).
// Shown inside the blank space until the owner-supplied photo is installed.
export const PHOTO_BRIEFS = Object.freeze({
  "home-hero": "Welcoming view of the actual club or members exercising",
  "H05": "Trainer working with a member",
  "H06": "Member using a Reformer, or the Reformer studio",
  "H07": "Club pool or water-fitness session",
  "H08": "MX4 small-group training in action",
  "H09": "Supervised Kids & Family activity",
  "H10": "Actual recovery or massage service/room",
  "H11": "Cardio or cycling class",
  "H12": "Mind-body class such as yoga",
  "H13": "Group strength class",
  "H14": "Group class showing the range of club programs",
  "home-tour": "Inviting overview of the facility",
  "membership-hero": "Welcoming club detail for the membership header",
  "C01": "Club interior, team or member community",
  "amenities-hero": "Broad view of club facilities",
  "C07": "Facility area available to rent",
  "C06": "Actual club community partnership or event",
  "P00": "Training activity showing the club program offering",
  "P03": "Personal trainer coaching a member",
  "P02": "MX4 small-group training",
  "P01": "Reformer Pilates class or equipment",
  "P04": "Swimming instructor and swimmer during a lesson",
  "P05": "Supervised Kids & Family activity",
  "P07": "Cardio or cycling class",
  "P08": "Mind-body class such as yoga",
  "P06": "Massage therapist/service or actual treatment room",
  "C05": "Welcoming supervised childcare or family activity",
  "schedule-F01-Cardio%20floor%20and%20treadmills": "Cardio floor and treadmills",
  "C02": "Cardio floor",
  "C03": "Group fitness class",
  "schedule-mind-body": "Mind-body class, such as yoga or stretching",
  "schedule-F05-Dumbbells%20on%20a%20training%20floor": "Dumbbells or actual strength-training floor",
  "swim-hero": "Swimming instructor helping a swimmer in the club pool",
  "A01": "Basketball court",
  "A02": "Club pools",
  "A03": "Spacious club interior",
  "A04": "Sauna and/or steam room",
  "A05": "Private locker rooms",
  "A06": "Rockwall",
  "A07": "Pickleball court or play",
  "A09": "Strength-training floor with racks and free weights",
  "A10": "Cardio floor with treadmills",
  "coach-andy": "Andy — recognizable head-and-shoulders portrait",
  "coach-heidi": "Heidi — recognizable head-and-shoulders portrait",
  "coach-jenn-l": "Jenn — recognizable head-and-shoulders portrait",
  "coach-pam": "Pam — recognizable head-and-shoulders portrait",
  "coach-david": "David — recognizable head-and-shoulders portrait",
  "coach-jamir": "Jamir — recognizable head-and-shoulders portrait",
  "coach-toni": "Toni — recognizable head-and-shoulders portrait",
  "coach-ty": "Ty — recognizable head-and-shoulders portrait",
  "coach-lisa": "Lisa — recognizable head-and-shoulders portrait",
  "coach-john": "John — recognizable head-and-shoulders portrait",
  "coach-sara": "Sara — recognizable head-and-shoulders portrait",
  "coach-jesus": "Jesus — recognizable head-and-shoulders portrait",
  "article-can-you-do-reformer-pilates-while-pregnant": "Reformer or mat Pilates matching this article",
  "article-what-is-a-sports-massage": "Massage treatment or room matching this article",
  "article-can-i-do-strength-training-after-a-massage": "Massage treatment or room matching this article",
  "article-mx4-workout": "MX4 or small-group training matching this article",
  "article-is-hiit-strength-training": "MX4 or small-group training matching this article",
  "article-when-to-start-swim-lessons": "Pool exercise or swim instruction matching this article",
  "article-does-pilates-help-you-lose-weight": "Reformer or mat Pilates matching this article",
  "article-is-water-aerobics-good-for-weight-loss": "Pool exercise or swim instruction matching this article",
  "article-dive-in-and-trim-down-unpacking-the-calories-burned-in-water-aerobics": "Pool exercise or swim instruction matching this article",
  "article-how-much-does-a-pilates-class-cost": "Reformer or mat Pilates matching this article",
  "article-is-hiit-safe-during-pregnancy": "MX4 or small-group training matching this article",
  "article-what-to-wear-to-pilates": "Reformer or mat Pilates matching this article",
  "article-how-often-to-do-hiit-training": "MX4 or small-group training matching this article",
  "article-small-group-training": "MX4 or small-group training matching this article",
  "article-how-much-does-a-personal-trainer-cost": "Trainer working with an individual or small group",
  "article-small-group-personal-training": "Trainer working with an individual or small group",
  "article-transform-your-core-the-ultimate-guide-to-exercise-ball-core-strength-training": "Exercise-ball core training",
  "article-what-is-reformer-pilates": "Reformer or mat Pilates matching this article",
  "article-power-stretch": "Yoga or stretching class matching this article",
  "article-pre-natal-massage": "Massage treatment or room matching this article",
  "article-yoga-flow-class": "Yoga or stretching class matching this article",
  "article-yoga-muscle-fusion": "Yoga or stretching class matching this article",
  "article-aqua-jogging-pool-walking-the-low-impact-cardio-youre-missing": "Pool exercise or swim instruction matching this article",
  "article-mat-pilates-vs-reformer-pilates-which-is-right-for-you": "Reformer or mat Pilates matching this article",
  "article-sports-massage-for-recovery": "Massage treatment or room matching this article",
  "article-the-complete-guide-to-water-fitness-at-delta-valley-from-aqua-aerobics-to-deep-water-training": "Pool exercise or swim instruction matching this article",
  "article-youth-swimming-programs-in-brentwood-discovery-bay-delta-valleys-complete-parent-guide": "Pool exercise or swim instruction matching this article",
  "article-gym-with-childcare-in-brentwood-work-out-while-your-kids-play": "Supervised childcare activity",
  "article-indoor-cycling-spin-classes-guide": "Indoor cycling class",
  "article-indoor-rock-climbing-gym-brentwood": "Indoor rockwall and climber",
  "article-pickleball-for-beginners-brentwood-delta-valley-health-club": "Pickleball play or court",
  "article-senior-fitness-classes-brentwood": "Older adults exercising at the club",
});
